import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import GTLabel from "components/GTLabel";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import Table from "./Table";
import NavBar from "components/SideBar/SideBar2";
import "../style.css";
import NewEmailConfiguration from "./NewConfigPopup";
import AnimatedNotificationIcon from "../Utility/Bellicon";
import EmailPopup from "./EmailPopup";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
// import {  setSelectedGstin } from "../Notice/action";
import {
  getEmailConfigurations,
  getGstinListConfig,
  setActiveTab,
  setSelectedGstin,
} from "./action";
import { getGstinList } from "../Notice/action";
import Schedular from "../Notice/Schedular";

export default function Email(props) {
  const dispatch = useDispatch();
  const { loaderStatus, gstins } = useSelector(
    (state) => state.emailConfigReducer
  );
  const gstinList = useSelector((state) => state.noticeReducer.gstinList);
  const [showPopup, setShowPopup] = useState(false);
  const [ShowSchedular, setShowSchedular] = useState(false);

  const handleClosePopup = () => setShowPopup(false);

  const handleOpenPopup = async () => {
    try {
      const result = await dispatch(getGstinList());
      // Don't rely on gstinList from useSelector here as it might be stale
      console.log("GSTIN list fetch result:", result);
      setShowPopup(true);
    } catch (error) {
      console.log("Error in handleOpenPopup:", error);
    }
  };
  const handleCloseSchedular = () => {
    setShowSchedular(false);
  };
  const handleOpenSchedular = () => {
    setShowSchedular(true);
  };

  const handleGstin = async (currentNode, selectedNodes) => {
    const selectedGstinValue =
      selectedNodes.length > 0
        ? selectedNodes[0]?.value || selectedNodes[0]?.label
        : "";
    dispatch(setSelectedGstin(selectedGstinValue));
    // console.log("Selected GSTIN:", selectedGstinValue);

    // Call API to fetch email configurations for selected GSTIN
    try {
      if (selectedGstinValue) {
        await dispatch(getEmailConfigurations(selectedGstinValue));
      } else {
        await dispatch(getEmailConfigurations()); // Get all configurations when no GSTIN selected
      }
    } catch (error) {
      console.log("Error fetching email configurations for GSTIN:", error);
    }
  };

  const handleTabChange = (tab) => {
    // Dispatch action to set active tab in the reducer
    dispatch(setActiveTab(tab));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Reset selected GSTIN before fetching
        dispatch(setSelectedGstin([]));
        
        await Promise.all([
          dispatch(getGstinListConfig()),
          dispatch(getEmailConfigurations())
        ]);
      } catch (error) {
        console.log("Error fetching initial data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSelectedGstin([]));
      handleClosePopup()
    };
  }, []);
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <div className="sweet-loading">
        <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
      </div>
      <NavBar
        currentPage="Notice | Email Configuration"
        module="notice"
        history={props.history}
      >
        <div className="email-dropdown-section">
          {/* <AnimatedNotificationIcon /> */}

          <div className="dropdown-container-notice">
            <GTLabel
              title={"Select GSTIN *"}
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            />
            <Container
              mode="simpleSelect"
              data={gstins?.map((gstin) => ({
                label: gstin,
                value: gstin,
                checked: false,
              }))}
              onChange={handleGstin}
              isDisabled={gstins?.length === 0}
              searchable={true}
            />
          </div>

          <div 
          className="email-action-button"
          >
            {/* <Button
              id="email-new-configuration-button"
              variant="contained"
              color="primary"
              onClick={handleOpenSchedular}
            >
              Schedular
            </Button> */}
            <Button
              id="email-new-configuration-button"
              variant="contained"
              style={{marginLeft:'1em'}}
              color="primary"
              onClick={handleOpenPopup}
            >
              New Configuration
            </Button>
          </div>

          {showPopup && (
            // <NewEmailConfiguration open={showPopup} onClose={handleClosePopup} />
            <EmailPopup open={showPopup} onClose={handleClosePopup} />
          )}
          <Schedular open={ShowSchedular} onClose={handleCloseSchedular} handleTabChange={handleTabChange}/>
        </div>

        <Table />
      </NavBar>
    </>
  );
}
